import {Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import { CollaborationState } from '../../store/collaboration.reducer';

import {GetConversationChatAction
} from '../../store/collaboration.action';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { GraphqlContentScope } from '@shared/models/graphql-content-scope.model';
import { animate, style, transition, trigger } from '@angular/animations';
import { CollaborationConfig } from '../../store/collaboration.config';
import { CollaborationQuery } from '../../store/collaboration.query';
import { ContentScope } from '@shared/commands/command-base';
import {takeUntil} from 'rxjs/operators';

import {SecurityState} from '@shared/store/reducers/security.reducer';
import {QuickViewState} from '@shared/quick-view/quick-view.reducer';

import {getUserInfo} from '@shared/store/selectors/security.selector';
import {DialogService} from '@shared/services/dialog-service';
import {ContactState, getAllContacts} from '../../../../contacts/store/contact.reducer';
import {GetAllSharedContactsAction} from '../../../../contacts/store/contact.action';
import {ConversationBaseComponent} from '../conversation-base/conversation-base.component';
import {SnackBarService} from '@core/services/snack-bar.service';
import {RightSidebarWaitScreenService} from '@core/services/right-sidebar-waitcreen.service';
import {ICollaborationProviderComponent} from '@shared/components/platform-sidebar/store/view-synchronizer.interfaces';
import {ViewSynchronizerService} from '@shared/components/platform-sidebar/store/view-synchronizer.service';


@Component({
    standalone: false,
    selector: 'chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  animations : [
    trigger('fadeIn', [
      transition(':enter', [
        style({opacity: '0'}),
        animate('.5s ease-out', style({opacity: '1'}))
      ])
    ])
  ]
})
export class ChatComponent extends ConversationBaseComponent implements OnInit, ICollaborationProviderComponent, OnDestroy {
  data: any;
  allContacts$: any;
  allContacts: Array<any> = [];
  hashTagList: any;

  constructor (public collaborationStore: Store<CollaborationState>,
               public quickViewStore: Store<QuickViewState>,
               public platformSidebarStore: Store<PlatformSidebarState>,
               public dialog: MatDialog,
               public snackbarService: SnackBarService,
               public router: Router,
               public activatedRoute: ActivatedRoute,
               public securityStore: Store<SecurityState>,
               public rightSidebarWaitScreenService: RightSidebarWaitScreenService,
               public contactStore: Store<ContactState>,
               public viewSynchronizerService: ViewSynchronizerService,
               public dialogService: DialogService
  ) {
    super(collaborationStore, snackbarService, dialog, dialogService, securityStore, rightSidebarWaitScreenService);
    this.viewSynchronizerService.setProvider(this);
  }

  ngOnInit () {
    this.initComponent();
    this.SubscribeToCurrentChatConversation();
    this.subscribeToDeleteMessageNotification();
    this.securityStore.select(getUserInfo).pipe(takeUntil(this.unsubscribe$)).subscribe(currentUser => {
      this.currentUser = currentUser;
      this.initDefaultRoles();
    });
    if (this.data && this.data.componentInfo && this.data.componentInfo.data) {
      let scope = '';
      let conversationId = this.data.componentInfo.data;
      if (this.data.componentInfo.data.indexOf('support-') !== -1) {
        scope = GraphqlContentScope.getScope(ContentScope.OrbitaxSupport);
        conversationId = this.data.componentInfo.data.replace('support-', '');
      } else {
        scope = GraphqlContentScope.getScope(ContentScope.Company);
      }
      this.platformSidebarStore.dispatch(new GetConversationChatAction(CollaborationConfig.CollaborationApiKey,

        CollaborationQuery.getChatConversationById(conversationId, scope), ''));
    }

    this.allContacts$ = this.contactStore.select(getAllContacts).pipe(takeUntil(this.unsubscribe$));
    this.allContacts$.subscribe(data => {
      if (data) {
        this.allContacts = data.raw;
        // this.allContacts = this.allContacts.filter(contact => contact.status !== 1); // if you want to avoid 'request pending' contacts
      }
    });
  }

  ngOnDestroy () {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getId(message) {
    const id = 'quick-' + message.sequence;
    // console.log(id);
    return id;
  }
  onShowDac6Card(event) {
    // console.log('show dac6 card:', event);
  }

  onCancelReply(event) {
    if (event) {
      this.replyToMessage = null;
    }
  }

  private initComponent () {
    this.numOfMessageToDisplay = 10;
    this.allContacts = [];
    this.hashTagList = ['#DAC6'];
    this.contactStore.dispatch(new GetAllSharedContactsAction());
  }

  onRevertToOldValue(messageData) {
    this.viewSynchronizerService.handleMessageAction('revertToOldValue', messageData);
  }

  setCurrentContext(contextId) {
  }

  setCurrentConversation(conversationId) {
  }

  postMessage(conversationId, message) {
  }

  setComponentToInitialState() {
  }
}
